import config from 'cfg';
// import { requestAsync, httpMethods, UPDATE_DEFAULT } from 'dash-front/requery/actions';
import {
    WIDGETS_LOAD,
    WIDGET_CMP_LOADED,
    WIDGET_JSPROP_CHANGE,
    WIDGET_SELECTED,
    WIDGET_JSPROP_UPDATE_FILELD,
    EDITOR_TAB_OPEN,
    EDITOR_ZOOM,
    EDITOR_AUTO_ZOOM,
    EDITOR_RESET_WIDGET,
    EDITOR_SET_TEMPLATE,
    // EDITOR,
    EDITOR_SET_PREVIEW_STATUS,
} from './constants';
import auth from 'dash-front/auth';

import _ from 'lodash';

export const loadWidgetCMP = widgetId => dispatch => {
    if (!widgetId) {
        return;
    }
    window.wdploadsm(widgetId, {}, {}, () => {
        dispatch({
            type: WIDGET_CMP_LOADED,
            payload: widgetId,
        });
    });
};

export const loadWidgets = () => dispatch => {
    return fetch(`${config.dash.api.host}/api/widgets/spec?access_token=${auth.getAccessToken()}&social=true`)
        .then(response => response.json())
        .then(({ widgets }) => {
            return dispatch({
                type: WIDGETS_LOAD,
                payload: {
                    set: 'all',
                    widgets,
                },
            });
        });
};

export const loadWidget = (widgetId, params = {}, keep = false) => (dispatch, getState) => {
    const state = getState();

    if (widgetId === state.editor.widgetId) return;
    return fetch(`${config.dash.api.host}/api/widgets/${widgetId}/spec?access_token=${auth.getAccessToken()}`)
        .then(res => (res.status === 200 ? res.json() : new Error(res.text())))
        .then(widget => {
            const state = getState();
            const { user } = state;
            // EXPERIMENTAL. set user defaults.

            const { username, client } = user;

            // let lang = user.defaultProps.find(({ key }) => key === 'lang');
            // let timezone = user.defaultProps.find(({ key }) => key === 'timezone');

            const { lang = 'da', tz = 'CET' } = user.props;

            const defProps = { lang, tz, username, client };
            if (keep) {
                params = state.editor.jsprops;
            }

            // if (_.isEmpty(params) && widget.layouts) {
            //     dispatch(opentTab(EDITOR.TABS.LAYOUT));
            // }
            dispatch({
                type: WIDGET_SELECTED,
                payload: {
                    widget,
                    params: { ...defProps, ...params },
                },
            });
        })
        .catch(e => {
            alert('e' + e.message);
        });
};

export const opentTab = tab => dispatch => {
    dispatch({
        type: EDITOR_TAB_OPEN,
        payload: tab,
    });
};

export const setEditorAutoZoom = autozoom => dispatch => {
    return dispatch({
        type: EDITOR_AUTO_ZOOM,
        payload: autozoom,
    });
};

export const setEditorZoom = (zoom, autozoom) => {
    return {
        type: EDITOR_ZOOM,
        payload: { zoom, autozoom },
    };
};

export const setEditorWidget = widgetId => (dispatch, getState) => {
    const state = getState();

    if (widgetId != state.editor.widgetId) {
        // remove from selected params wcwidth, cause new layout can have its own wcwidth
        const { wcwidth, ...newProps } = state.editor.jsprops;
        dispatch(
            loadWidget(widgetId, {
                ...newProps,
            }),
        );
    }
};

export const changeWidgetJSProp = payload => dispatch => {
    dispatch({
        type: WIDGET_JSPROP_CHANGE,
        payload,
    });
};

export const updateWidgetJSPropField = (field, update) => dispatch => {
    return dispatch({
        type: WIDGET_JSPROP_UPDATE_FILELD,
        payload: {
            field,
            update,
        },
    });
};

export const resetSelectedWidget = () => dispatch => {
    dispatch({
        type: EDITOR_RESET_WIDGET,
    });
};

export const setWidgets = (widgets, set) => dispatch => {
    return dispatch({
        type: WIDGETS_LOAD,
        payload: {
            set,
            widgets,
        },
    });
};

export const setTemplate = template => dispatch => {
    return dispatch({
        type: EDITOR_SET_TEMPLATE,
        payload: template,
    });
};

export const setPreviewStatus = (status, error) => dispatch => {
    return dispatch({
        type: EDITOR_SET_PREVIEW_STATUS,
        payload: { status, error },
    });
};

export const recalculateArea = (id, update) => (dispatch, getState) => {
    const { editor } = getState();

    let area = _.get(editor, `widgetProps.${id}`, {});

    area = { ...area, ...update };

    if (!isValid(area)) {
        dispatch({
            type: WIDGET_JSPROP_UPDATE_FILELD,
            payload: {
                field: id,
                update: {
                    ...update,
                    ...calcFitPosition(area),
                },
            },
        });
    } else {
        dispatch({
            type: WIDGET_JSPROP_UPDATE_FILELD,
            payload: {
                field: id,
                update,
            },
        });
    }
};

const isValid = area => {
    const { width, height, scale, x, y, cw, ch } = area;

    const realWidth = width * scale;
    const realHeight = height * scale;

    const reachX = realWidth + x;
    const reachY = realHeight + y;

    const coverLeft = x <= 0.1;
    const coverRight = reachX - cw >= -0.1;

    const coverTop = y <= 1;
    const coverBottom = reachY - ch >= -0.5;

    return coverLeft && coverRight && coverTop && coverBottom;
};

const calcFitPosition = area => {
    const { width, height, cw, ch } = area;
    const neededScaleX = cw / width;
    const neededScaleY = ch / height;

    const scale = +Math.max(neededScaleX, neededScaleY).toFixed(3);
    const x = (cw - width * scale).toFixed(3) / 2;
    const y = (ch - height * scale).toFixed(3) / 2;

    return {
        scale,
        x,
        y,
    };
};



/** WEBPACK FOOTER **
 ** ../src/dash/front/editor/actions.js
 **/